const filels = "custom_content/ls/maintenance.json";
const filemw = "custom_content/mw/maintenance.json";
const filelsconfig = "custom_content/ls/config.json";
const filemwconfig = "custom_content/mw/config.json";

const checkMaintenanceLS = async (key) => {
        try {
        const response = await fetch(filels);
        const data = await response.json();
            //console.log("Data:", data);
            // Retorna el valor de la llave si existe
            const value = data[key];
            return value;
        } catch (error) {
            console.error("Error:", error);
            return null;
        }

}

const checkMaintenanceMW = async (key) => {
        try {
        const response = await fetch(filemw);
        const data = await response.json();
            //console.log("Data:", data);
            // Retorna el valor de la llave si existe
            const value = data[key];
            return value;
        } catch (error) {
            console.error("Error:", error);
            return null;
        }

}

const checkConfigLS = async (key) => {
        try {
        const response = await fetch(filelsconfig);
        const data = await response.json();
            const value = data[key];
            return value;
        } catch (error) {
            console.error("Error:", error);
            return null;
        }

}

const checkConfigMW = async (key) => {
        try {
        const response = await fetch(filemwconfig);
        const data = await response.json();
            const value = data[key];
            return value;
        } catch (error) {
            console.error("Error:", error);
            return null;
        }

}

export default {
    checkMaintenanceLS,
    checkMaintenanceMW,
    checkConfigLS,
    checkConfigMW
}